var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body-code",class:{'is_fixed':_vm.isFixed},attrs:{"id":"boxFixed"}},[_c('img',{attrs:{"src":"/static/homeIcon/QRcode.png"}}),_c('div',{staticClass:"title"},[_vm._v("技术主题推送")])])}
var staticRenderFns = []

export { render, staticRenderFns }